import { render, staticRenderFns } from "./SwiperDefault.vue?vue&type=template&id=170d645a&"
import script from "./SwiperDefault.vue?vue&type=script&lang=js&"
export * from "./SwiperDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports